import { CssBaseline, createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import { Route, Routes } from "react-router";
import { setUpAxios } from "@entrilia/shared/api/axiosHelper";
import { updateClientCode } from "@entrilia/shared/api/clientApiContext";
import LoggedOut from "@entrilia/shared/auth/LoggedOut";
import { initAuthSettings } from "@entrilia/shared/auth/settings";
import Error from "@entrilia/shared/components/Error";
import { Licenses } from "@entrilia/shared/licensing";
import { initAppInsights } from "@entrilia/shared/logging";
import { lightThemeOptions } from "@entrilia/shared/theme";
import App from "./App";
import Authentication from "./auth/Authentication";
import { redirectToSignin } from "./auth/authRedirects";
import Logout from "./auth/Logout";
import { pageRoutes } from "./routes";
import { getEntriliaOrgClientCode } from "./utilities/clientHelper";
import { importAuthSettings } from "./variables";

LicenseInfo.setLicenseKey(Licenses.MUI_X_PREMIUM_KEY);

initAppInsights({ appId: "Operations" });
initAuthSettings(importAuthSettings());
updateClientCode(getEntriliaOrgClientCode());
setUpAxios(redirectToSignin, []);

const theme = createTheme(lightThemeOptions);

const Entry = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Routes>
        <Route path={pageRoutes.oauth} element={<Authentication />} />
        <Route path={pageRoutes.logout} element={<Logout />} />
        <Route path={pageRoutes.loggedOut} element={<LoggedOut href="./" />} />
        <Route path={pageRoutes.error} element={<Error />} />
        <Route path="*" element={<App />} />
      </Routes>
    </ThemeProvider>
  );
};

export default Entry;
